<style scoped>
@import '../../assets/css/developer.css';
</style>

<template>
<div>
    <div class="main-panel" v-if="ajaxLoad === true">
        <div class="main-content">
            <div class="container-fluid">
                <b-card>
                    <b-tabs class="center_pane" justified fill>
                        <b-tab :title="$t('developer_center.table_reset_permission')">
                            <b-card>
                                <b-button variant="info" @click="updateAdminPermission()" v-if="permissionList.includes(permission.admin)">{{$t('developer_center.error_reset_admin_permission')}}</b-button>
                                <b-button variant="info" @click="updateMemberPermission()" v-if="permissionList.includes(permission.member)" class="ml-2">{{$t('developer_center.error_reset_member_permission')}}</b-button>
                            </b-card>
                        </b-tab>

                        <b-tab title="Rerun Bonus">
                            <b-form-checkbox-group v-model="rerun">
                                <b-row>
                                    <b-col cols="12" v-for="(list,key) in rerunList" :key="key">
                                        <b-form-checkbox :value="list.code" class="mt-2" >{{list.name}}</b-form-checkbox>
                                    </b-col>
                                </b-row>
                            </b-form-checkbox-group>
                            <b-button variant="info" class="mt-3 w-100" @click="reRun()">Rerun</b-button>
                        </b-tab>
                    </b-tabs>
                </b-card>   
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {centerAjaxTable,updateAdminPermission,updateMemberPermission,reRunMethod} from '@/system/model/developer'
import {removeTokenByName} from '@/system/store/cookie';
import {getSessionStorage,setSessionStorage } from '@/system/store/sessionstorage';
import {setLocalStorage, getLocalStorage} from '@/system/store/localstorage';

export default {
    inject:['preloader'],
    data(){
        return{
            ajaxLoad:false,
            csrfName:'',
            csrfValue:'',
            csrfNameKey:'',
            csrfValueKey:'',
            rerunList:[],
            rerun:[],
            permission:{
                admin:'627417',
                member:'62B8E7',
            },
            permissionList:[],
        }
    },
    methods:{
        initialize(){
            var self = this;
            var result = centerAjaxTable();
            this.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.ajaxLoad = true;
                    self.csrfName = value.data.csrf_list.csrf_name;
                    self.csrfValue = value.data.csrf_list.csrf_value;
                    self.csrfNameKey = value.data.csrf_list.csrf_name_key;
                    self.csrfValueKey = value.data.csrf_list.csrf_value_key;
                    self.rerunList = value.data.test_function;
                    self.permissionList = JSON.parse(getLocalStorage('permission_list'));
                }else{
                    self.$swal.fire({
                        type: 'error',
                        html: self.$t('login.error_relogin'),
                        onClose: () => {
                            removeTokenByName('auth_sign_token');
                            self.$router.push('/');
                        }
                    });		
                }
            });
        },updateAdminPermission(){
            if(this.permissionList.includes(this.permission.admin)){
                this.$swal.fire({
                text: 'Are you want sure want to reset?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('job_id', '2'); 
                        var result = updateAdminPermission(formData);
                        self.preloader(true);
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();                             
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }

                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();                             
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },updateMemberPermission(){
            if(this.permissionList.includes(this.permission.member)){
                this.$swal.fire({
                text: 'Are you want sure want to reset?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('button.confirm'),
                cancelButtonText: this.$t('button.cancel'),
                }).then((result)=>{
                    if(result.value){
                        var self = this;
                        var form = document.getElementById('addAttributePackage');
                        var formData = new FormData();
                        formData.append(this.csrfNameKey, this.csrfName); 
                        formData.append(this.csrfValueKey, this.csrfValue); 
                        formData.append('job_id', '2');             
                        var result = updateMemberPermission(formData);
                        self.preloader(true);
                        result.then(function(value){
                            self.preloader(false);
                            if(value.valid){
                                self.$swal.fire({
                                    type: 'success',
                                    text: self.$t(value.returnMsg),
                                    onClose: () => {
                                        self.initialize();                   
                                    }
                                });
                            }else{
                                self.preloader(false);
                                var text = "";
                                if(Array.isArray(value.returnMsg)){
                                    value.returnMsg.forEach(function (value) {
                                        text += self.$t(value)+"<br />";
                                    }); 
                                }else{
                                    text = self.$t(value.returnMsg);
                                }
                                self.$swal.fire({
                                    type: 'error',
                                    html: text,
                                    onClose: () => {
                                        self.initialize();       
                                    }
                                });
                            }
                        });
                    }
                });
            }
        },reRun(){
            var self = this;
            var formData = new FormData();
            formData.append(this.csrfNameKey, this.csrfName); 
            formData.append(this.csrfValueKey, this.csrfValue); 
            formData.append('code', this.rerun);             
            var result = reRunMethod(formData);
            self.preloader(true);
            result.then(function(value){
                self.preloader(false);
                if(value.valid){
                    self.$swal.fire({
                        type: 'success',
                        text: self.$t(value.returnMsg),
                        onClose: () => {
                            self.initialize();                   
                        }
                    });
                }else{
                    self.preloader(false);
                    var text = "";
                    if(Array.isArray(value.returnMsg)){
                        value.returnMsg.forEach(function (value) {
                            text += self.$t(value)+"<br />";
                        }); 
                    }else{
                        text = self.$t(value.returnMsg);
                    }
                    self.$swal.fire({
                        type: 'error',
                        html: text,
                        onClose: () => {
                            self.initialize();       
                        }
                    });
                }
            });
        }
    },
    created(){
        this.preloader(false)
        this.initialize();
    }
}
</script>
